// externals
import { Reducer } from 'redux';

// actions
import { Actions } from './actions';
// interfaces
import { ILeadform } from '../types/ILeadform';
import { zipUtils } from '@makemydeal/dr-activities-common';

export const initialState: ILeadform = {
    isModalOpen: false,
    isFromBuyOnlineButton: false,
    title: '',
    description: '',
    successAction: '',
    meta: undefined,
    errorDescription: '',
    externalErrorCount: 0,
    skipLink: false,
    leadFormSubmittedSuccess: false,
    leadFormSubmitting: false,
    leadFormSubmittedFailure: false,
    leadFormReinitialized: false,
    ccpaShown: false,
    currentZip: '',
    dealerZip: '',
    isCCPAEnabled: false,
    zipCodeLoading: false,
    zipCodeFailure: false,
    submissionFlowName: '',
    initialSubmissionFlowName: ''
};

export const reducer: Reducer<ILeadform> = (state: ILeadform = initialState, action: any) => {
    const { payload, type } = action;

    switch (type) {
        case Actions.OPEN_LEAD_FORM_MODAL: {
            return { ...state, ...payload, isModalOpen: true };
        }
        case Actions.CLOSE_LEAD_FORM_MODAL: {
            return {
                ...state,
                ...payload,
                isModalOpen: false,
                externalErrorCount: 0,
                successAction: '',
                meta: undefined,
                leadFormSubmitting: false,
                isFromBuyOnlineButton: false
            };
        }
        case Actions.SET_LEAD_FORM_MODAL_ERROR: {
            return {
                ...state,
                ...payload,
                externalErrorCount: (state.externalErrorCount += 1),
                leadFormSubmitting: false
            };
        }
        case Actions.SP_DXG_SAVE_REQUEST:
        case Actions.LEAD_FORM_SUBMITTED:
        case Actions.OFFER_SUBMISSION_REQUEST: {
            return {
                ...state,
                leadFormSubmitting: true
            };
        }
        case Actions.SP_DXG_SAVE_REQUEST_SUCCESS:
        case Actions.LEAD_FORM_SUBMISSION_SUCCESS:
        case Actions.OFFER_SUBMISSION_SUCCESS: {
            return {
                ...state,
                leadFormSubmittedSuccess: true,
                leadFormSubmitting: false,
                leadFormSubmittedFailure: false,
                leadFormReinitialized: false
            };
        }
        case Actions.SP_DXG_SAVE_REQUEST_FAILURE:
        case Actions.FAILED_TO_BUILD_DXG_SAVE_PAYLOAD:
        case Actions.LEAD_FORM_SUBMISSION_FAILURE:
        case Actions.OFFER_SUBMISSION_FAILURE: {
            return {
                ...state,
                leadFormSubmittedSuccess: false,
                leadFormSubmitting: false,
                leadFormSubmittedFailure: true,
                leadFormReinitialized: false
            };
        }
        case Actions.LEAD_FORM_FLOW_UPDATE: {
            return {
                ...state,
                ...payload
            };
        }
        case Actions.INITIAL_FORM_FLOW_UPDATE: {
            return {
                ...state,
                ...payload
            };
        }
        case Actions.REINITIALIZE_LEAD_FORM: {
            return {
                ...state,
                leadFormSubmittedSuccess: false,
                leadFormSubmitting: false,
                leadFormSubmittedFailure: false,
                leadFormReinitialized: true
            };
        }
        case Actions.INIT_SUCCESS: {
            const dealer = action.payload.dealer || {};
            const offer = action.payload.offer || {};
            const hasBeenSent = offer.hasBeenSent || false;
            return {
                ...state,
                leadFormSubmittedSuccess: hasBeenSent,
                dealerZip: dealer.address?.zip,
                isCCPAEnabled: !!dealer.isCCPAEnabled
            };
        }

        case Actions.DEALXG_GET_SUCCESS: {
            return {
                ...state,
                leadFormSubmittedSuccess: action.payload.offer.hasBeenSent
            };
        }

        case Actions.USPS_ZIP_REQUEST: {
            return {
                ...state,
                zipCodeLoading: true,
                zipCodeFailure: false
            };
        }
        case Actions.USPS_ZIP_SUCCESS: {
            const zipResultsArray: zipUtils.USPSCityStateZip[] = action.payload;
            const ccpaShown = zipResultsArray.filter((zipResult: zipUtils.USPSCityStateZip) => zipResult.state === 'CA').length > 0;

            return {
                ...state,
                ccpaShown,
                zipCodeLoading: false
            };
        }
        case Actions.USPS_ZIP_FAILURE: {
            return {
                ...state,
                zipCodeLoading: false,
                zipCodeFailure: true
            };
        }
        case Actions.SET_IS_FROM_BUY_ONLINE_BUTTON: {
            return {
                ...state,
                isFromBuyOnlineButton: action.payload
            };
        }
        case Actions.LEAD_FORM_SET_META: {
            return {
                ...state,
                meta: action.payload
            };
        }
        default: {
            return state;
        }
    }
};
